export default {
  thereIsNoMessages: 'پیامی وجود ندارد',
  inboxOf(companyName: string) {
    return `صندوق پیام ${companyName}`;
  },
  loadMore: 'بیشتر',
  archived: 'بایگانی شده',
  new: 'جدید',
  archive: 'بایگانی کردن',
  restore: 'برگرداندن',
  inbox: 'صندوق پیام',
};
